import Attachments from '@/components/attachments/Attachments'
import AttachmentDetail from '@/components/attachments/AttachmentDetail'
import AttachmentCreate from '@/components/attachments/AttachmentCreate'
import AttachmentUpdate from '@/components/attachments/AttachmentUpdate'
import AttachmentCreatePromissory from '@/components/attachments/AttachmentCreatePromissory'

const attachmentsRoutes = [
  { path: '/attachments', name: 'attachments', component: Attachments },
  { path: '/attachment/create', name: 'attachment_create', component: AttachmentCreate },
  { path: '/attachment/update/:id', name: 'attachment_update', component: AttachmentUpdate },
  { path: '/attachment/:id', name: 'attachment', component: AttachmentDetail },
  { path: '/attachment/:id/promissories/create', name: 'attachment_create_promissory', component: AttachmentCreatePromissory }
]

export default attachmentsRoutes



// WEBPACK FOOTER //
// ./src/router/attachments_routes.js